import userService from 'api/user';

const handleError = (error) => {
  let result = error;

  if (typeof error.json === 'function') {
    error
      .json()
      .then((errorJson) => {
        result = errorJson;
      })
      .catch(() => {
        result = error;
      });
  } else {
    result = error;
  }

  return result;
};

export default {
  getFamilyMembers: (searchValue, index) => (dispatch) => new Promise((resolve, reject) => {
    dispatch({ type: 'GET_FAMILYMEMBERS' });
    userService
      .getPublicInformationBySearch(searchValue, index)
      .then((response) => {
        response.json().then((responseJson) => {
          dispatch({ type: 'GET_FAMILYMEMBERS_SUCCESS', data: responseJson });
          resolve(responseJson);
        });
      })
      .catch((error) => {
        const errorInfo = handleError(error);

        dispatch({ type: 'GET_FAMILYMEMBERS_FAIL', error: errorInfo });
        reject(errorInfo);
      });
  }),
  setGoalcardReceiver: (receiverUser) => (dispatch) => {
    dispatch({ type: 'SET_GOALCARD_RECEIVER', receiverUser });
  },

  setGoalcardDestinationGoal: (destinationGoal) => (dispatch) => {
    dispatch({ type: 'SET_GOALCARD_DESTINATION_GOAL', destinationGoal });
  },
};
